import MainLayout from 'layouts/MainLayout';

import Start from '../pages/Start';
import Conversation from '../pages/Conversation';

const routes =  [{
    layout: MainLayout,
    routes: [{
        path: '/agents/rossato-orari/:agentId',
        element: Start,
        exact: true,
        analytics: { name: ["Agente", "Rossato orari"] },
    }, {
        path: '/agents/rossato-orari/:agentId/conversations/:conversationId',
        element: Conversation,
        exact: true,
        analytics: { name: ["Agente", "Conversazione"] },
    }]
}]

export default routes;